const batchTypes = [
  { label: "Regular", value: "Regular" },
  { label: "Multi-licence", value: "Multilicence" },
];

export default batchTypes;
